
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/section",
      function () {
        return require("private-next-pages/section/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/section"])
      });
    }
  